import Footer from "../../organisms/Footer";
import { Suspense } from "react";
import { Outlet, ScrollRestoration, useLocation, } from "react-router-dom";
import Header from "../../organisms/Header";
import ModalSignIn from "../../organisms/ModalSignIn";
import LoadingPage from "../../../pages/loading-page";
import { useSelector } from "react-redux";
import WhatsAppButton from "../../atoms/WhatsAppButton";
import { whatsappNumber } from "../../../constanta";

const MainLayout = () => {
  const loginModal = useSelector(state => state.loginModal)
  const location = useLocation();
  const currentPath = location.pathname.split('/')[1];
  
  return (
    <div className="overflow-x-hidden">
      {currentPath !== 'verification' && <Header />}
      <div>
        <Suspense fallback={<LoadingPage />}>
          <Outlet />
        </Suspense>
        <Footer />
        <ScrollRestoration />
      </div>
      <ModalSignIn openModal={loginModal}/>
      <WhatsAppButton phoneNumber={whatsappNumber} />
    </div>
  )
}

export default MainLayout;